import "./Petition.css";
import petitionHercPdf from "../assets/images/vol1com.pdf";
import volume2 from "../assets/images/Volume2com.pdf";
import volume3 from "../assets/images/volume3com.pdf";
import BriefPetition from "../assets/images/BriefPetition.pdf";
import { trackLinkClick } from "../utils/mixpanel";

function Petition() {
  const petitions = [
    {
      title: "Petition HERC",
      url: petitionHercPdf,
    },
    {
      title: "Annexures Volume II",
      url: volume2,
    },
    {
      title: "Annexures Volume III",
      url: volume3,
    },
    {
      title: "Brief Petition",
      url: BriefPetition,
    },
  ];

  return (
    <section className="petition" id="petition">
      <h2>Petition for distribution license</h2>
      <div className="petition-cards">
        {petitions.map((item, index) => (
          <div key={index} className="petition-card">
            <div className="petition-icon">
              <svg width="40" height="48" viewBox="0 0 40 48" fill="none">
                <rect
                  x="0"
                  y="0"
                  width="40"
                  height="48"
                  rx="4"
                  fill="#fff"
                  stroke="#ddd"
                />
                <rect x="8" y="14" width="24" height="2" rx="1" fill="#ccc" />
                <rect x="8" y="20" width="24" height="2" rx="1" fill="#ccc" />
                <rect x="8" y="26" width="18" height="2" rx="1" fill="#ccc" />
                <rect
                  x="24"
                  y="0"
                  width="16"
                  height="12"
                  rx="2"
                  fill="#E53935"
                />
                <text x="26" y="9" fontSize="7" fill="#fff" fontWeight="bold">
                  PDF
                </text>
              </svg>
            </div>
            <h3>{item.title}</h3>
            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="petition-link"
              onClick={(e) => {
                e.preventDefault();
                trackLinkClick(item.title, item.url);
                setTimeout(() => window.open(item.url, "_blank"), 300);
              }}
            >
              Read more
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Petition;
